import { mode, transparentize } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { theme } = props;
    return {
        borderRadius: 'base',
        transition: 'all 0.2s',
        color: mode(transparentize('gray.600', 0.67)(theme), transparentize('white', 0.7)(theme))(props),
        _disabled: {
            opacity: 0.4,
            cursor: 'not-allowed',
            boxShadow: 'none',
        },
        _hover: { bg: mode(`blackAlpha.100`, `whiteAlpha.100`)(props) },
        _active: { bg: mode(`blackAlpha.200`, `whiteAlpha.200`)(props) },
        _focus: {
            boxShadow: 'outline',
        },
    };
};
const sizes = {
    lg: {
        w: '42px',
        h: '42px',
        fontSize: '16px',
    },
    md: {
        w: '36px',
        h: '36px',
        fontSize: '15px',
    },
    sm: {
        w: '30px',
        h: '30px',
        fontSize: '14px',
    },
};
const defaultProps = {
    size: 'md',
};
export default {
    baseStyle: getBaseStyle,
    sizes,
    defaultProps,
};
//# sourceMappingURL=close-button.js.map